import { userRegisterMutation } from "../../../../api/backend/account/register/api"
import { RegistrationInput } from "../../../../api/backend/backend-api"
import { AppThunk } from "../../../../state/store"
import { saveAuthToken } from "../../services/authService"
import {
  userRegisterFailure,
  userRegisterStart,
  userRegisterSuccessful,
} from "./registrationSlice"

export const registerUser = (
  input: RegistrationInput,
  callback?: () => void
): AppThunk => async (dispatch) => {
  try {
    dispatch(userRegisterStart())
    const { data } = await userRegisterMutation(input)
    if (!data || !data.register) {
      throw Error("Empty mutation response")
    }

    if (data.register.errorType) {
      dispatch(
        userRegisterFailure({
          type: data.register.errorType.toString(),
        })
      )
    }

    if (data.register.success) {
      dispatch(
        userRegisterSuccessful({
          email: input.email,
          firstName: input.name,
          lastName: input.surname,
          username: input.email,
        })
      )
      if (data.register.accessToken) {
        saveAuthToken(data.register.accessToken)
      }
      if (callback) {
        callback()
      }
    }
  } catch (e) {
    dispatch(
      userRegisterFailure({
        type: "genericError",
        details: e,
      })
    )
  }
}
